import { useQuery } from "react-query";
import { getDealersCategories } from "~/pages/Editor/EditorStaff/requests/GetDealersCategories/getDealersCategories";

export default function useGetDealersCategories() {
  return useQuery({
    queryKey: ["getDealersCategories"],
    queryFn: () => getDealersCategories(),
    refetchOnWindowFocus: false,
    cacheTime: 0,
  });
}
